import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "@mui/material/Skeleton";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import AuthLogin from "CommonComponents/AuthForms/AuthLogin.jsx";
import { ThemeContext } from "context/ThemeContext";
import { AuthContext } from "context/Authentication";
import { getReturnUrlFromLocation } from "utils/authUtils";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import commonStyles from "globalassets/styles/commonStyles";

export default function Login() {
  const themeMode = useContext(ThemeContext);
  const darkMode = themeMode.state.darkMode;
  const context = useContext(AuthContext);
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const cardMediaImage = context.state?.companyInfo?.Secondary_Back_Image
    ? process.env.BASEURL + context.state.companyInfo?.Secondary_Back_Image
    : "none";

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
  };

  const handleContinueAsUser = () => {
    const returnUrl = getReturnUrlFromLocation(location);
    if (returnUrl) {
      navigate(returnUrl);
    } else {
      navigate(context.state?.user?.Default_Page);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: 2,
        position: "relative",
      }}
    >
      <Tooltip title="Toggle Color Mode">
        <IconButton
          aria-label="darkmode"
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            color: darkMode ? "primary.light" : "primary.main",
          }}
          onClick={() => {
            darkMode
              ? themeMode.dispatch({ type: "LIGHTMODE" })
              : themeMode.dispatch({ type: "DARKMODE" });
          }}
        >
          {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </Tooltip>
      <Card
        sx={{
          display: "flex",
          width: "100%",
          maxWidth: 900,
          borderRadius: 4,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
        }}
      >
        {/* Left Side: Image */}
        {context.state.companyInfo?.Secondary_Back_Image && (
          <CardMedia
            component="img"
            image={cardMediaImage}
            alt="Background"
            sx={{
              width: "50%",
              display: { xs: "none", sm: "block" },
              borderRadius: "4px 0 0 4px",
            }}
          />
        )}

        {/* Right Side: Form */}
        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: 4,
          }}
        >
          <Box
            sx={{ textAlign: "center", mb: 3, cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            {context.state.companyInfo &&
            Object.entries(context.state.companyInfo).length > 0 ? (
              <img
                alt={context.state.companyInfo.Company_Name}
                src={
                  darkMode
                    ? process.env.BASEURL +
                      context.state.companyInfo.Company_Logo_Light
                    : process.env.BASEURL +
                      context.state.companyInfo.Company_Logo_Dark
                }
                style={{ height: 65 }}
                // css={commonStyles.brandlogo}
              />
            ) : (
              <Skeleton variant="circular">
                <Avatar
                  sx={{
                    width: 65,
                    height: 65,
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                />
              </Skeleton>
            )}
          </Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Login Your Account
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            Login to explore products tailored for you.
          </Typography>
          {context.state?.isAuthenticated && context.state?.user ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleContinueAsUser}
              >
                Continue as {context.state?.user?.Full_Name}
              </Button>
              <Button variant="text" color="secondary" onClick={handleLogout}>
                Sign In as Different User
              </Button>
            </Box>
          ) : (
            <AuthLogin />
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
